module.exports = __webpack_public_path__ + "img/one.581deeff.jpg";